import SpecialIco from "./special/ico/main";

const specialIco = new SpecialIco();
